<mat-toolbar class="page-header">Webhook Signing Key</mat-toolbar>

<app-authorized-guard
  [authorized]="!unauthorized"
  message="You are not authorized to edit your webhook signing key."
>
  <app-loading-guard [loading]="loading">
    <div *ngIf="item$ | async as item">
      <form class="entity-form">
        <mat-form-field class="form-field">
          <input
            matInput
            name="webhook_signing_key"
            [type]="inputState.type"
            readonly
            [value]="item.webhook_signing_key"
          />
          <button
            matSuffix
            mat-icon-button
            [aria-label]="inputState.label"
            (click)="toggleKeyVisibility()"
          >
            <mat-icon [svgIcon]="inputState.icon"></mat-icon>
          </button>
        </mat-form-field>
        <div class="button-bar">
          <button
            mat-raised-button
            color="warn"
            (click)="confirmRegenerateKey()"
          >
            Regenerate Key
          </button>
          <button
            mat-raised-button
            color="warn"
            (click)="confirmClearKey()"
            [disabled]="!item.webhook_signing_key"
          >
            Clear Key
          </button>
        </div>
      </form>
    </div>
  </app-loading-guard>
</app-authorized-guard>
